import { Grid, TextField } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import { addMenoresAction, addItemsAction, addIndividualAction } from "../../../../../ducks/cotizadorPaqueteDuck"
import { ToastMessage } from "../../../../../global/ToastMessage"
import { catTipoPlaza } from "../../../../../constant/catTipoPlaza"
import { catTipoPago } from "../../../../../constant/catTipoPago"
import { catTipoItem } from "../../../../../constant/catTipoItem"

const FieldMenores = () => {
    const { metodoPago, fechaSalida, cantidadInfantes, listaHabitaciones, cantidadMenores, paquete, cantidadAdultos, clavePaquete, listaItems } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()
    const handleChange = (event) => {
        const newCantidadPasajeros = event.target.value
        const sumaCantidadPasajeros = Number(newCantidadPasajeros) + Number(cantidadAdultos) + Number(cantidadInfantes)
        const supHabitacion = listaHabitaciones.find(plaza => plaza.IdTipoPlaza === catTipoPlaza.Menorinfante)
        if (!supHabitacion) {
            ToastMessage.fire({
                icon: "info",
                title: "No hay habitacion de menores e infantes para este paquete",
            })
            return null
        }
        if (Number(newCantidadPasajeros) < 0) {
            ToastMessage.fire({
                icon: "info",
                title: "La cantidad de pasajeros debe ser mayor o igaul a uno",
            })
            return null
        }
        if (Number(cantidadAdultos) < 1) {
            ToastMessage.fire({
                icon: "info",
                title: "Para agregar un menor tienes que agregar por lo menos un adulto",
            })
            return null
        }
        let arrayItems = [...listaItems]
        let precio = paquete?.PrecioPublico
        // if (Number(metodoPago) === catTipoPago.PLAN_PAGOS) {
        //     precio = paquete?.PrecioDescuento
        // }
        arrayItems = listaItems.filter(item => item.type !== catTipoItem.PLAZAM && item.type !== catTipoItem.PLAZA)
        if (sumaCantidadPasajeros > 2 && Number(newCantidadPasajeros) >= 1) {
            let itemHabitacion = {
                id: supHabitacion.IdObjeto,
                name: `${supHabitacion.Descripcion}`,
                price: supHabitacion.Suplemento + precio,
                currency: paquete.Moneda?.Clave,
                type: catTipoItem.PLAZAM,
                quantity: newCantidadPasajeros,
            }
            if (Number(cantidadAdultos) === 1) {
                itemHabitacion.quantity = newCantidadPasajeros - 1
            }
            arrayItems.push(itemHabitacion)
        }
        dispatch(addIndividualAction({ individual: "0" }))
        dispatch(addMenoresAction({ cantidad: newCantidadPasajeros }))
        dispatch(addItemsAction({ listaItem: arrayItems }))
    }
    return (
        <Grid container>
            <Grid item xs={12}>
                <TextField
                    disabled={clavePaquete === "0" || fechaSalida === "0,0,0"}
                    value={cantidadMenores}
                    style={{ width: "95%", margin: "0.5rem 0" }}
                    id={`outlined-number-menores`}
                    label="Menores"
                    name="menores"
                    onChange={handleChange}
                    type="number"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        inputProps: { min: 0, max: 10 }
                    }}
                    variant="outlined"
                />
            </Grid>
        </Grid>
    )
}
export default FieldMenores